import { Box, Paper, Typography, useTheme } from "@mui/material";
import { BarragemCard } from "../barragem";
import { useEffect, useRef, useState } from "react";
import { useUserContext } from "../../context";

interface Props {
  barragens: number[];
}

export const Barragens: React.FC<Props> = ({ barragens }) => {
  const user = useUserContext();

  const theme = useTheme();

  const boxRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(50);

  const widthSize = 256;
  const spacing = 25;

  // Adicionando o botão para inserir uma nova barragem
  useEffect(() => {
    if (!user || "error" in user) return;
  }, []);

  useEffect(() => {
    if (boxRef.current) {
      const { width } = boxRef.current.getBoundingClientRect();
      setWidth(width);
    }
  }, [boxRef.current]);

  let nItemsRow = Math.max(Math.round(width / widthSize), 1);
  if (nItemsRow > 1) {
    while (itemsWidth(nItemsRow, spacing, widthSize) > width) {
      nItemsRow--;
      if (nItemsRow === 1) break;
    }
  }

  const widthSpacing = (width - (nItemsRow * widthSize) - (nItemsRow - 1) * spacing) / 2;

  const rows: number[][] = [];
  let row: number[] = [];
  barragens.forEach((element, i) => {
    row.push(element);

    if ((i + 1) % nItemsRow === 0) {
      rows.push(row);
      row = [];
    }
  });
  if (row.length) rows.push(row);
  row = [];

  return <Paper ref={boxRef} sx={{
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginBottom: "15px",
  }}>
    <div style={{ height: "15px" }} />

    <Typography
      fontWeight={"bold"}
      fontSize={"1.8em"}
      sx={{ paddingLeft: "2em" }} >
      Estruturas
    </Typography>

    <div style={{
      margin: "15px",
      marginBottom: "21px",
      backgroundColor: theme.palette.primary.main,
      height: "0.2em",
    }} />

    {rows.map((row, i) => {
      return <div key={i} style={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{
          display: "flex",
          flexDirection: "row",
        }}>
          <div style={{ width: `${widthSpacing}px` }} />
          {
            row.map((id, j) => {
              return <div key={`${i}${j}`} style={{ display: "flex" }}>
                <BarragemCard
                  barragemId={id}
                  width={Math.min(widthSize, width)}
                />
                {j != (row.length - 1) && <div style={{ width: `${spacing}px` }} />}
              </div>;
            })
          }

          <div style={{ flex: 1 }} />
        </Box>
        {i != (rows.length - 1) && <div style={{ height: `${spacing}px` }} />}
      </div>;
    })}

    <div style={{ height: "50px" }} />
  </Paper>;
};

const itemsWidth = (nItems: number, spacing: number, width: number) => {
  return (nItems * width) + (nItems + 1) * spacing;
};

